import { message } from '../utility/message'
import validation from '../utility/validation/validation-plugin'

const AuthForm = {
  el: {
    root: document.querySelectorAll < HTMLElement > ('.auth-login'),
  },

  init() {
    if (this.el.root.length > 0) {
      this.el.root.forEach((target) => {
        const el = {
          submitButton: target.querySelector < HTMLButtonElement > ('button[type="submit"]'),
          message: target.querySelector < HTMLElement > ('.auth-form__message'),
          inputs: target.querySelectorAll < HTMLInputElement > ('[required]'),
          authMethodBtns: target.querySelectorAll < HTMLButtonElement > ('.auth__method-btn'),
          authForms: target.querySelectorAll < HTMLFormElement > ('.auth-form'),
          waitingTexts: target.querySelectorAll('.auth__waiting-text'),
          challengeTexts: target.querySelectorAll<HTMLHeadingElement>('.auth__waiting-challenge'),
          redirectForm: document.getElementById('redirectForm') as HTMLFormElement,
          culture: document.querySelector<HTMLInputElement>('input[name="culture"]').value,
        }

        // bara validate inputs í selectedauthform

        if (el.redirectForm != null) {
          const data = new FormData(el.redirectForm)
          if (data.get('redirectNow') === 'true') {
            el.redirectForm.submit()
          }
        }

        this.inputsHaveValue(el)
        el.authMethodBtns.forEach((btn, i) => {
          btn.addEventListener('click', () => {
            this.selectMethod(i, el)
          })
        })

        el.inputs.forEach((input) => {
          input.addEventListener('keyup', () => {
            this.inputsHaveValue(el)
          })

          input.addEventListener('click', () => {
            this.inputsHaveValue(el)
          })
        })

        el.authForms.forEach((authForm) => {
          authForm.addEventListener('submit', (e) => {
            e.preventDefault()
            e.stopPropagation()
            this.submitForm(el, e.target, e)
          })
        })

      })
    }
  },

  selectMethod(ind, el) {

    const unauthMessage = document.querySelector('.auth__unauthorized').classList.contains('hide')
    const waitingTextDisplayed = document.querySelector('.auth__waiting').classList.contains('hide')

    if (!unauthMessage) {
      return;
    }
    if (!waitingTextDisplayed) {
      return;
    }

    el.authForms.forEach((authForm) => {
      authForm.classList.add('hide')
    })
    el.authMethodBtns.forEach((authBtn) => {
      authBtn.classList.remove('auth__method--selected')
    })
    el.waitingTexts.forEach((text) => {
      text.classList.add('hide')
    })
    el.challengeTexts.forEach((challenge) => {
      challenge.classList.remove('challenge--active')
    })

    el.authForms[ind].classList.remove('hide')
    el.authMethodBtns[ind].classList.add('auth__method--selected')
    el.waitingTexts[ind].classList.remove('hide')
    el.challengeTexts[ind].classList.add('challenge--active')
  },

  inputsHaveValue(el) {
    /*let inputsHaveValue = true*/

    el.inputs.forEach((input) => {
      if (input.type === "text") {
        if (input.value.length === 0 || input.value === '' || input.value === null) {
          /*inputsHaveValue = false*/
        }
      }

      if (input.type === "checkbox") {
        if (!input.checked) {
         /* inputsHaveValue = false*/
        }
      }
    })

    // if (inputsHaveValue) {
    //   el.submitButton.disabled = false
    // } else {
    //   el.submitButton.disabled = true
    // }
  },

  async submitForm(el, form, e) {
    try {

      // @ts-ignore
      el.inputs = form.querySelectorAll('[required]')
      if (validation.validateForm(el.inputs)) {
        message.reset(el.message)

        const data = new FormData(form)
        const method = form.getAttribute('method')

        // create json data from form data

        let authRequestData = {
          phoneOrSsn: data.get('phoneOrSsn') as string,
          authType: data.get('authType') as string,
          culture: data.get('culture') as string
        }
        const authRequestJson = JSON.stringify(authRequestData)

        // show loading screen
        const authForm = form;
        const authWaiting = form.parentElement?.querySelector('.auth__waiting');
        const antiforgeryToken = form.parentElement?.querySelector('[name="ufprt"]').value

        authForm.classList.add('hide');
        authWaiting?.classList.remove('hide');

        // post to login controller
        await fetch(`${'/umbraco/surface/auth/login'}`, {
          method: method,
          body: authRequestJson,
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            RequestVerificationToken: antiforgeryToken
          },
        })
          .then((res) => {
            if (!res.ok) {
              console.log('login error', res.status)
            }
            return res.json();
          })
          .then((data) => {
            if (data.redirect != null) {
              // redirect to page
              this.redirectToPage(data, form);
              return;
            }
            const challenge = data.Challenge
            const activeChallenge = document.querySelector < HTMLHeadingElement > ('.challenge--active')
            activeChallenge.innerText = challenge
            this.startPolling(el, data, antiforgeryToken, form)

          })

      } else {
        e.preventDefault()
        message.show(el.message) // validation errors
      }
    }
    catch (error) {
      console.error('login error', error)
    }
  },

  async startPolling(el, response, antiforgeryToken, form) {
    const authWaiting = form.parentElement?.querySelector('.auth__waiting');
    console.log(el.culture,'culture')
    let pollRequestData = {
      culture: document.querySelector<HTMLInputElement>('input[name="culture"]').value,
      vacationUrl: false,
      AuthIdentifier: response.Identifier
    }

    const reqBody = JSON.stringify(pollRequestData)
    await fetch(`${'/umbraco/surface/auth/PollAuthorizationStatus'}`, {
      method: 'POST',
      body: reqBody,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        RequestVerificationToken: antiforgeryToken
      },
    })
      .then((res) => {
        if (!res.ok) {
          document.querySelector('.auth__unauthorized')?.classList.remove('hide')
          authWaiting?.classList.add('hide');
          console.error('polling failed - error', res.status)
        }
        return res.json()
      })
      .then((data) => {
        if (data.error != null) {
          document.querySelector('.auth__unauthorized')?.classList.remove('hide')
          authWaiting?.classList.add('hide');
          console.error(data.error)
        }
        if (data.redirect) {
          this.redirectToPage(data, form) // page will handle success / error
        }

        else {
          document.querySelector('.auth__unauthorized')?.classList.remove('hide')
          authWaiting?.classList.add('hide');
          console.log('error while logging in')
        }

      })
  },

  redirectToPage(data, form) {

    var fromData = new FormData(form)
    if (fromData.get('vacation') === 'True') {
      this.vacationRedirect(data)
      return;
    }

    const redirectUrl = window.location.origin + data.redirect
    window.location.href = redirectUrl
  },

  async vacationRedirect(data) {

    const redirectForm = document.getElementById('redirectForm') as HTMLFormElement;
    if (!redirectForm) return; // Check if the form exists

    const hashInput = redirectForm.elements.namedItem('hash') as HTMLInputElement;
    const ktInput = redirectForm.elements.namedItem('kt') as HTMLInputElement;

    if (hashInput && ktInput) {
      hashInput.value = data.hash;
      ktInput.value = data.kt;
      redirectForm.submit();
    }
  }
}

export default AuthForm
